export type ActivityGalleryImage = {
  id: string;
  src: string;
  srcSet: string;
  fullSrc: string;
  width: number;
  height: number;
  alt: string;
  caption: string;
};

const BASE = "/images/activities";

function galleryItem(
  n: number,
  width: number,
  height: number,
  alt: string,
  caption: string,
): ActivityGalleryImage {
  const id = `activity-${String(n).padStart(2, "0")}`;
  const webp = `${BASE}/${id}.webp`;
  const jpg = `${BASE}/${id}.jpg`;
  const mid = `${BASE}/${id}-800.webp`;
  return {
    id,
    src: webp,
    srcSet: width > 900 ? `${mid} 800w, ${webp} ${width}w` : `${webp} ${width}w`,
    fullSrc: jpg,
    width,
    height,
    alt,
    caption,
  };
}

/** All 15 migrated Activities gallery images with factual alt text. */
export const ACTIVITY_GALLERY: ActivityGalleryImage[] = [
  galleryItem(
    1,
    1044,
    783,
    "Guests serving themselves from a buffet table during a community meal in the Amigo Inn recreation hall",
    "Guests sharing food during an indoor gathering at Amigo Inn",
  ),
  galleryItem(
    2,
    1044,
    783,
    "Guests socializing around tables in the Amigo Inn recreation hall",
    "Guests gathering for conversation in the recreation hall",
  ),
  galleryItem(
    3,
    1044,
    783,
    "Guests sharing a meal around a round table inside the Amigo Inn recreation hall",
    "Guests seated together during a group dinner",
  ),
  galleryItem(
    4,
    1044,
    783,
    "Dessert table with cakes, pies, and cookies prepared for a guest celebration at Amigo Inn",
    "Dessert table prepared for a guest celebration",
  ),
  galleryItem(
    5,
    1044,
    783,
    "Guests lining up for a buffet meal with a Valentine's Day balloon in the Amigo Inn recreation hall",
    "Community celebration inside the Amigo Inn clubhouse",
  ),
  galleryItem(
    6,
    1044,
    783,
    "Guests seated at tables with New Year party hats during a holiday gathering at Amigo Inn",
    "Holiday gathering inside the Amigo Inn recreation hall",
  ),
  galleryItem(
    7,
    1044,
    783,
    "Three guests standing behind a buffet of fried fish and fries in the Amigo Inn recreation hall kitchen",
    "Guests gathered around a buffet meal at Amigo Inn",
  ),
  galleryItem(
    8,
    1044,
    783,
    "Guests gathered around an autumn-themed buffet table for a community meal at Amigo Inn",
    "Community meal inside the Amigo Inn recreation hall",
  ),
  galleryItem(
    9,
    1044,
    783,
    "Guests playing acoustic guitars and singing during a musical gathering in the Amigo Inn recreation hall",
    "Guests sharing music during a gathering at Amigo Inn",
  ),
  galleryItem(
    10,
    1044,
    783,
    "Guests sharing an evening meal at round tables inside the Amigo Inn recreation hall",
    "Guests seated together during a group dinner",
  ),
  galleryItem(
    11,
    1044,
    783,
    "Guests sharing a meal at a round table in the wood-paneled Amigo Inn recreation hall",
    "Guests sharing a meal during a gathering at Amigo Inn",
  ),
  galleryItem(
    12,
    1044,
    783,
    "Assorted pies and desserts arranged on a table for a guest celebration at Amigo Inn",
    "Dessert table prepared for a guest celebration",
  ),
  galleryItem(
    13,
    1044,
    783,
    "Long wooden shuffleboard table with a digital scoreboard in the Amigo Inn recreation room",
    "Shuffleboard table in the Amigo Inn game room",
  ),
  galleryItem(
    14,
    1044,
    783,
    "Guests sharing a community meal and conversation inside the Amigo Inn recreation hall",
    "Guests gathering for a special occasion at Amigo Inn",
  ),
  galleryItem(
    15,
    800,
    600,
    "Guests posing together in the Amigo Inn recreation hall near neon signs and a shuffleboard table",
    "Guests gathering for a special occasion at Amigo Inn",
  ),
];

export const ACTIVITIES_HERO = {
  src: `${BASE}/activities-hero.webp`,
  srcSet: `${BASE}/activities-hero-800.webp 800w, ${BASE}/activities-hero.webp 1800w`,
  fullSrc: `${BASE}/activities-hero.jpg`,
  width: 1800,
  height: 504,
  alt: "A travel trailer parked on a concrete pad under trees at Amigo Inn & RV Park on a bright day",
} as const;
